import { useGetPartnerUserDetails } from '@dazn/lp-web/src/hooks/useGetPartnerUserDetails';
import { useState, useEffect } from 'react';
import useQueryParam from './useQueryParam';

interface PartnerUserData {
    isAlreadyLinked: boolean | null;
    nextAction: string;
    isDaznUserExist: boolean;
    isPartnerUserExist: boolean;
    isNotSubscribedUser: boolean;
    [key: string]: any;
}

interface UseCanalPlusReturn {
    partnerUserData: PartnerUserData | null;
    authorizationCode: string;
    isNotSubscribedUser: boolean;
    isFetchingPartnerUserDetails: boolean;
}
export const useCanalPlus = (): UseCanalPlusReturn => {
    const [shouldFetchPartnerData, setShouldFetchPartnerData] = useState(false);
    const { value: authorizationCode, isError } = useQueryParam('code')

    useEffect(() => {
        if (authorizationCode && !isError) {
            setShouldFetchPartnerData(true);
        }
    }, [authorizationCode, isError]);

    const { partnerUserData: apiData, isNotSubscribedUser, isFetchingPartnerUserDetails } =
        useGetPartnerUserDetails({
            responseCode: shouldFetchPartnerData ? authorizationCode : ''
        }) ?? {};

    const partnerUserData: PartnerUserData | null = apiData
        ? {
            isAlreadyLinked: apiData.isAlreadyLinked || null,
            nextAction: apiData.nextAction || '',
            isDaznUserExist: apiData.isDaznUserExist || false,
            isPartnerUserExist: apiData.isPartnerUserExist || false,
            isNotSubscribedUser: isNotSubscribedUser,
            ...apiData
        }
        : null;

    return {
        partnerUserData,
        authorizationCode,
        isNotSubscribedUser,
        isFetchingPartnerUserDetails
    };
};
